import { Component, Input, OnInit } from '@angular/core';

export interface FedExLocation {
    location_id: string;
    location_name: string;
    address: string;
    distance: number;
    store_hours: any;
    store_hours_display: string;
}

@Component({
    standalone: false,
    selector: 'octo-fedex-location',
    templateUrl: './fedex-location.component.html',
    styleUrls: ['./fedex-location.component.scss'],
})
export class FedexLocationComponent implements OnInit {
    @Input() locationDetails: FedExLocation;

    constructor() {}

    ngOnInit(): void {}
}
